import {connect} from 'react-redux'
import SignUpForm from 'gui/pages/mainRouter/pages/signUp/components/signUpForm/SignUpForm';
import {getSignUpActionCreator} from 'data/redux/actions/authenticationActions';
import {
  isEmailUniqueErrorSelector,
  isInvalidRegisterRecaptchaSelector
} from 'data/redux/selectors/errorsSelector';
import {isLoadingSelector} from 'data/redux/selectors/guiSelector';

const mapStateToProps = (state, ownProps) => {
  return {
    emailUniqueError: isEmailUniqueErrorSelector(state),
    invalidRecaptcha: isInvalidRegisterRecaptchaSelector(state),
    loading: isLoadingSelector(state),
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (formValues) => dispatch(getSignUpActionCreator(formValues))
  };
};

const SignUpFormContainer = connect(mapStateToProps, mapDispatchToProps)(SignUpForm);

export default SignUpFormContainer;
